import { atom } from 'jotai';

export const OrderAttributionMapper = {
  trade: {
    recentHistory: 'SEARCH_RECENT_HISTORY',
    search: 'SEARCH',
    all: 'SEARCH_ALL',
    favorites: 'SEARCH_FAVORITES',
    positionsOpened: 'SEARCH_POSITIONS_OPENED',
    perpetual: 'SEARCH_PERPETUAL',
    spot: 'SEARCH_SPOT',
    spotDefault: 'TRADE_SPOT_DEFAULT',
    perpetualDefault: 'TRADE_PERPETUAL_DEFAULT',
    hottestNow: 'SEARCH_HOTTEST_PAIR',
  },
  market: {
    search: 'MARKET_SEARCH',
    searchRecentHistory: 'MARKET_SEARCH_RECENT_HISTORY',
    carouselZeroSpread: 'CAROUSEL_ZERO_SPREAD',
    categories: {
      openPosition: 'MARKET_CATEGORIES_POSITIONS_OPENED',
      holdings: 'MARKET_CATEGORIES_YOUR_HOLDINGS',
      hotTradingPairs: 'MARKET_CATEGORIES_HOT_TRADING_PAIRS',
      newListing: 'MARKET_CATEGORIES_NEW_LISTINGS',
      topMover: 'MARKET_CATEGORIES_TOP_MOVERS',
      highVolume: 'MARKET_CATEGORIES_HIGH_VOLUME',
      highFundingRate: 'MARKET_CATEGORIES_HIGH_FUNDING_RATES',
      yourFrequentTrade: 'MARKET_CATEGORIES_YOUR_FREQUENT',
      USD1: 'MARKET_CATEGORIES_USD1_PAIRS',
    },
    discover: {
      favorites: 'MARKET_DISCOVER_FAVORITES',
      marketCap: 'MARKET_DISCOVER_ALL',
      hotTradings: 'MARKET_DISCOVER_HOT_TRADINGS',
      newListings: 'MARKET_DISCOVER_NEW_LISTINGS',
      priceChange24h: 'MARKET_DISCOVER_TOP_MOVERS',
      volume: 'MARKET_DISCOVER_HIGH_VOLUMES',
      absFundingRates: 'MARKET_DISCOVER_HIGH_FUNDING_RATES',
      yourFrequentTrades: 'MARKET_DISCOVER_FREQUENT_TRADES',
      USD1: 'MARKET_DISCOVER_USD1_PAIRS',
    },
    economicEvents: 'MARKET_ECONOMIC_EVENTS',
    news: 'MARKET_NEWS',
    topTradersOpenPositions: (profileId?: string) =>
      `MARKET_TOP_TRADERS_OPEN_POSITIONS${profileId ? `:${profileId}` : ''}`,
  },
  marketNews: {
    economicEvents: 'ECONOMIC_EVENTS',
    news: 'MARKET_NEWS',
  },
  earn: {
    extraApr: 'EARN_EXTRA_APR',
    earnIncreaseLimit: 'EARN_INCREASE_LIMIT',
    earnTraders: 'EARN_TRADERS',
    earnTradingBonusNudge: 'EARN_TRADING_BONUS_NUDGE',
  },
  asset: {
    assetSpotTrade: 'ASSET_SPOT_TRADE',
    assetPerpTrade: 'ASSET_PERP_TRADE',
    assetPerpPositionSymbol: 'ASSET_PERP_POSITION_SYMBOL',
  },
  profile: {
    performance: (profileId?: string) => `PROFILE_PERFORMANCE${profileId ? `:${profileId}` : ''}`,
    tradingActivity: (profileId?: string) => `PROFILE_TRADING_ACTIVITY${profileId ? `:${profileId}` : ''}`,
    socialFeedPosition: (profileId?: string) => `PROFILE_SOCIAL_FEED_POSITION${profileId ? `:${profileId}` : ''}`,
  },
  vip: {
    vipTradeRebate: 'VIP_TRADE_REBATE',
  },
  orderForm: {
    economicEventsOrderForm: 'ECONOMIC_EVENTS_ORDER_FORM',
    marketNewsOrderForm: 'MARKET_NEWS_ORDER_FORM',
  },
  leaderboard: {
    weeklyPnlTrade: 'WEEKLY_PNL_TRADE',
  },
  insights: {
    socialFeedPosition: 'INSIGHTS_SOCIAL_FEED_POSITION',
  },
  profitBoost: {
    profitBoostPage: 'PROFIT_BOOST_PAGE',
  },
  zeroSpread: {
    zeroSpreadPage: 'ZERO_SPREAD_PAGE',
  },
  usd1Points: {
    usd1PointsPage: 'USD1_PAGE_TRADE_SECTION',
  },
};

export const orderAttributionAtom = atom<string | undefined>(undefined);
